import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryQuestions(
  {
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryQuestion(questionId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions/${questionId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addQuestion(
  {
    title,
    titleEn,
    content,
    contentEn,
    // isActive,
    // answers,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions`,
    method: 'post',
    data: {
      title,
      titleEn,
      content,
      contentEn,
      // isActive,
      // answers,
    },
  });
}

/**
 * 更新
 * @param questionId
 * @param  title
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateQuestion(questionId, {
  title,
  titleEn,
  content,
  contentEn,
  // isActive,
  // answers,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions/${questionId}`,
    method: 'patch',
    data: {
      title,
      titleEn,
      content,
      contentEn,
      // isActive,
      // answers,
    },
  });
}

/**
 * 删除
 * @param questionId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteQuestion(questionId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions/${questionId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param questionId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upQuestion(questionId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions/${questionId}/up`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param questionId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downQuestion(questionId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/questions/${questionId}/down`,
    method: 'patch',
  });
}

export default {};
